export const formatEmailLink = (email: string, subject?: string, body?: string) => {
  return `mailto:${email}${subject ? `?subject=${subject}` : ''}${subject && body ? `&body=${body}` : ''}`
}
